export default __webpack_public_path__ + "static/UniversalDesignAndVisitability-7993fdc4167bc5f8a8868382ec21d79b.jpg";